export * from "@vaadin/tabs/vaadin-tabs.js";
export * from './generated/Tabs.js';
